import apiClient from '../api/apiClient';

/**
 * Upload a file to the utility upload endpoint.
 * @param {File} file - The file to upload
 * @param {string} folder - Folder name: 'logos' | 'investor_note' (or others as per API)
 * @returns {Promise<{ success: boolean, url?: string, message?: string }>}
 */
export async function uploadFile(file, folder) {
  if (!file || !folder) {
    return { success: false, message: 'File and folder are required' };
  }

  const formData = new FormData();
  formData.append('file', file);
  formData.append('folder', folder);

  try {
    const response = await apiClient.request({
      method: 'POST',
      url: '/api/v1/utility/upload',
      data: formData,
      // Omit Content-Type so axios sends multipart/form-data with boundary (API expects form-data, not JSON)
      headers: {
        'Content-Type': false,
      },
    });

    const data = response?.data;
    if (data?.success && data?.data?.url) {
      return {
        success: true,
        url: data.data.url,
        original_name: data.data.original_name,
        size: data.data.size,
        mime_type: data.data.mime_type,
      };
    }

    return {
      success: false,
      message: data?.message || 'Upload failed',
    };
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      'Upload failed';
    return { success: false, message };
  }
}

/**
 * Folder names for upload API (use these when calling uploadFile).
 */
export const UPLOAD_FOLDERS = {
  LOGOS: 'logos',
  INVESTOR_NOTE: 'investor_note',
  BANNERS: 'banners',
  WHATSAPP_SPECIAL_BROADCASTS: 'whatsapp-special-broadcasts',
};

export default { uploadFile, UPLOAD_FOLDERS };
